// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__37b3I","content":"RecentSearches_content__2q_pI"};